<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title class="redColor text-white d-flex">
        <span class="headline"> {{ $t("vehicle_entry.transfer.label") }} </span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row wrap>
          <!-----------------------------------------ALERT----------------------------------------->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-alert
              :model-value="alert"
              type="warning"
              variant="tonal"
              border="bottom"
            >
              <v-row align="center" class="py-1">
                <v-col cols="12" sm="6">
                  {{ $t("vehicle_entry.transfer.alert_message") }}
                </v-col>
                <v-col cols="12" sm="6">
                  <!-- Mobile: stacked full-width buttons -->
                  <div class="d-flex d-sm-none flex-column ga-2 mt-2">
                    <v-btn
                      variant="outlined"
                      color="success"
                      block
                      @click="((confirm = true), (alert = false))"
                    >
                      {{ $t("parts.inventory.actions.alert.yes") }}
                    </v-btn>
                    <v-btn
                      variant="outlined"
                      color="error"
                      block
                      @click="((confirm = false), (alert = false))"
                    >
                      {{ $t("parts.inventory.actions.alert.no") }}
                    </v-btn>
                  </div>
                  <!-- Desktop: unchanged inline buttons -->
                  <v-row class="d-none d-sm-flex pt-2">
                    <v-btn
                      variant="outlined"
                      size="small"
                      color="success"
                      class="ma-1"
                      @click="((confirm = true), (alert = false))"
                    >
                      {{ $t("parts.inventory.actions.alert.yes") }}
                    </v-btn>
                    <v-btn
                      variant="outlined"
                      size="small"
                      color="error"
                      class="ma-1"
                      @click="((confirm = false), (alert = false))"
                    >
                      {{ $t("parts.inventory.actions.alert.no") }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
          <!--------------------------------------INSTITUTION-------------------------------------->
          <v-col cols="12" xs="12">
            <v-autocomplete
              v-model="institution"
              :items="institutions"
              :loading="loadingInstitution"
              :label="$t('vehicle_entry.institution')"
              item-title="title"
              item-value="_id"
              variant="outlined"
              color="red-darken-1"
            />
          </v-col>
          <!--------------------------------------------------------------------------------------->
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" depressed variant="outlined" @click="close">
          {{ $t("vehicle_entry.close") }}
        </v-btn>
        <v-btn
          color="success"
          variant="outlined"
          :disabled="!confirm || !institution"
          :loading="loadingTransfer"
          @click="transfer"
        >
          {{ $t("vehicle_entry.transfer.transfer") }}
          <v-icon end> mdi-swap-horizontal </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import getRequest from "../../api/getRequest";
import putRequest from "../../api/putRequest";

export default {
  components: {},
  data: () => ({
    dialog: false,
    confirm: false,
    alert: false,
    car: null,
    institution: null,
    institutions: [],
    loadingInstitution: false,
    loadingTransfer: false,
  }),
  watch: {
    dialog(value) {
      if (!value) this.close();
    },
    institution(value) {
      if (value) this.alert = true;
    },
  },
  methods: {
    open(data) {
      this.dialog = true;
      this.getInstitutions();
      this.car = data.car;
    },
    close() {
      this.dialog = false;
      this.confirm = false;
      this.alert = false;
      this.car = null;
      this.institution = null;
      this.institutions = [];
      this.loadingInstitution = false;
      this.loadingTransfer = false;
      this.$emit("close");
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/transfer")
        .then((response) => {
          this.institutions = response.institutions.filter(
            (i) =>
              i._id.toString() !== this.$store.getters.institutionId.toString(),
          );
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },
    transfer() {
      this.loadingTransfer = true;
      putRequest("/car/transfer", "", {
        car_id: this.car._id,
        institution_id: this.institution,
      })
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loadingTransfer = false;
          this.close();
        });
    },
  },
};
</script>
